import { render, staticRenderFns } from "./twitterdialog.vue?vue&type=template&id=74a916f8"
import script from "./twitterdialog.vue?vue&type=script&lang=js"
export * from "./twitterdialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports